export default "__VITE_PUBLIC_ASSET__358b7de7__"